// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-bc813c72] .el-divider--horizontal{margin:20px 0!important}[data-v-bc813c72] .el-divider__text.is-left{left:0}[data-v-bc813c72] .el-divider__text{padding:0 10px 0 0}[data-v-bc813c72] .el-upload--picture-card{width:68px;height:68px;line-height:72px;vertical-align:top}[data-v-bc813c72] .el-upload-list--picture-card .el-upload-list__item{width:68px;height:68px}", ""]);
// Exports
module.exports = exports;
